export default "__VITE_ASSET__DBTjPgth__"